import React from 'react'
import { Button } from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import PropTypes from 'prop-types'
import hasErrorsQ from '../../../helpers/assessment/uploadCSV/hasErrorsQ'

/**
 * 
 * Button allows CSV to be processed after verification
 * is complete.
 */
function ProcessButton ({
  handleProcess,
  verified,
  verifyErrors,
  processing,
}) {
  const has_errors = hasErrorsQ(verifyErrors)
  if (has_errors) {
    return (
      <Button disabled>
        Correct Errors Before Continuing
      </Button>
    )
  }
  if (!verified) return null
  return (
    <Button onClick={handleProcess} disabled={processing}>
      {!processing && 'Process'}
      <BeatLoader color={'#ffffff'} loading={processing} />
    </Button>
  )
}

const { bool, func, object } = PropTypes
ProcessButton.propTypes = {
  handleProcess: func.isRequired,
  processing: bool,
  verified: bool,
  verifyErrors: object,
}

export default ProcessButton


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/ProcessButton.js